import { logger, MarketConsentOptions, ProgramTheme,  } from '@sheerid/jslib';
import { getOptions } from '../../options/options';

const defaultMarketConsent: MarketConsentOptions = {
    enabled: false,
    required: false,
    message: "",
  };

export const getMarketConsent = (programTheme: ProgramTheme): MarketConsentOptions => {
    let marketConsent: MarketConsentOptions = { ...defaultMarketConsent };
    try {
      if (programTheme.config.marketConsent) {
        marketConsent = programTheme.config.marketConsent;
      }
    } catch (e) {
      // market consent is not coming for this program from server. Default will be used
      logger.warn("Server did not provided a market consent config. Default will be used");
    }
    if (getOptions().marketConsent) {
      marketConsent = getOptions().marketConsent;
    }
    return marketConsent;
};
